import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import "../main.css"

const IndexPage = () => (
    <Layout>
        <SEO title="Home" />
        <div id="content">
            <div className="fp">
                <h2>Welcome to Tactical Tinkering!</h2>Here you'll find a number of stimulating, interesting, and hopefully
                entertaining projects from my hobbyist repertoire.<br/><br/>You'll find projects in <strong>engineering</strong>, <strong>programming</strong>, and even <strong>cooking</strong> &ndash; but they all share one common ground: they're
                all about <strong>making things!</strong><br/><br/>If this is your first visit, why not make one of the top picks (above right) your first port of call?<br/><br/><b>Happy tinkering!</b>
            </div><br/>
            <div className="fp" style={{ backgroundColor: '#DCFFDC' }}>
                <h3 style={{ color: '#000' }}>Who am I?</h3>Hi there, my name is Dan Brown. Allow me to summarise myself in bullet point form:
                <ul>
                    <li>Recent graduate in theoretical physics from the University of St Andrews.</li>
                    <li>Pathological tinkerer.</li>
                    <li>Engineering, programming, and general making-things enthusiast.</li>
                </ul>
            </div>
        </div>
    </Layout>
)

export default IndexPage
